import i18n from 'i18next';

function t(value, options) {
    return i18n.t(value, options)
}

export { t };